import PageAnchor from "./PageAnchor";

export default PageAnchor;
